import { CallTypeEnum } from '../enums/callType';
import { LocationTypeEnum } from '../enums/locationType';

export class CosDataTo {
    cos: string;
    callType: CallTypeEnum;
    locationType: LocationTypeEnum;

    constructor(object?: any) {
        if (object) {
            this.cos = object.cos;
            this.callType = object.callType;
            this.locationType = object.locationType;
        }
    }
}
